import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listMedicines } from "../../Redux/actions/patientActions/medicineActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";

const MedicineScreen = () => {
  const dispatch = useDispatch();
  const { loading, error, medicines } = useSelector((state) => state.medicines);

  useEffect(() => {
    dispatch(listMedicines());
  }, [dispatch]);

  return (
    <div className="container mt-4">
      <h2>Medicines</h2>
      {loading && <Loading />}
      {error && <Error message={error} />}
      <table className="table table-striped mt-3">
        <thead>
          <tr>
            <th>Name</th>
            <th>Price (PKR)</th>
            <th>Quantity Sold</th>
          </tr>
        </thead>
        <tbody>
          {medicines && medicines.map((med) => (
            <tr key={med._id}>
              <td>{med.name}</td>
              <td>{med.price}</td>
              <td>{med.quantitySold || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MedicineScreen;
